import { render, staticRenderFns } from "./departList.vue?vue&type=template&id=903ea486&scoped=true&"
import script from "./departList.vue?vue&type=script&lang=js&"
export * from "./departList.vue?vue&type=script&lang=js&"
import style0 from "./departList.vue?vue&type=style&index=0&lang=less&"
import style1 from "./departList.vue?vue&type=style&index=1&id=903ea486&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "903ea486",
  null
  
)

export default component.exports